"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var colors = _interopRequireWildcard(require("HubStyleTokens/colors"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _utils = require("../../utils/utils");

function ThumbnailVideoDuration(_ref) {
  var duration = _ref.duration;
  return _react.default.createElement("div", {
    className: "thumbnail__video-duration flex-row align-center"
  }, _react.default.createElement(_UIIcon.default, {
    name: "playerPlay",
    color: colors.OLAF,
    size: 9,
    className: (0, _classnames.default)('m-top-1', {
      'm-right-0': !duration
    })
  }), duration && _react.default.createElement("span", null, (0, _utils.millisecondsToTimer)(duration)));
}

ThumbnailVideoDuration.propTypes = {
  duration: _propTypes.default.number
};
var _default = ThumbnailVideoDuration;
exports.default = _default;
module.exports = exports.default;